import { getDeviationUrl } from '../DeviationViews/_helpers';
import MediaService from '../utils/DeviationMediaService';
export function getDeviationShareCodes(deviation) {
    const preview = MediaService.getDeviationFile(deviation, 'preview');
    const embedCode = deviation.extended && deviation.extended.isEmbeddable && deviation.extended.embedCode || undefined;
    return {
        url: getDeviationUrl(deviation),
        media: preview && preview.src,
        embedCode
    };
}
